export default "__VITE_ASSET__B4V5tDOO__"